import type { TilesSourceBounds } from '@sharefe/share3d-engine'
import { OFFICE_TILES_AUDIT } from './officeTilesAudit'

export type TilesFixtureKey = 'delaunay_image' | 'poisson_las' | 'delaunay_image_ktx2' | 'poisson_las_ktx2'

export const TILES_FIXTURE_MANIFEST = OFFICE_TILES_AUDIT.manifestSha256
const origin = typeof window !== 'undefined' && !['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)
  ? window.location.origin : 'http://10.10.20.73'
const modelUrl = (name: string) => `${origin}/tiles-fixtures/${name}/3dtiles/tileset.json`
export const TILES_FIXTURES: Record<
  TilesFixtureKey,
  {
    readonly title: string
    readonly url: string
    readonly sourceBounds: TilesSourceBounds
  }
> = {
  delaunay_image: {
    title: 'office-delaunay-image · 普通纹理',
    url: modelUrl('office-delaunay-image'),
    sourceBounds: { min: [-15.625677, -2.246591, -2.412654], max: [4.344285, 23.550969, 3.225536] },
  },
  poisson_las: {
    title: 'office-poisson-las · 普通纹理',
    url: modelUrl('office-poisson-las'),
    sourceBounds: { min: [-14.7186, -2.334658, -2.599211], max: [4.548217, 34.315041, 3.36581] },
  },
  delaunay_image_ktx2: {
    title: 'office-delaunay-image-ktx2 · 压缩纹理',
    url: modelUrl('office-delaunay-image-ktx2'),
    sourceBounds: { min: [-15.625677, -2.246591, -2.412654], max: [4.344285, 23.550969, 3.225536] },
  },
  poisson_las_ktx2: {
    title: 'office-poisson-las-ktx2 · 压缩纹理',
    url: modelUrl('office-poisson-las-ktx2'),
    sourceBounds: { min: [-14.7186, -2.334658, -2.599211], max: [4.548217, 34.315041, 3.36581] },
  },
}

/** 固定 Z-up 米制机位；两份数据分别复现，双资产时建议先 fitAll。 */
export const TILES_CAMERA_TRAJECTORY = [
  { name: '总览', position: [28, -28, 24], target: [-5, 13, 0], zoom: 1 },
  { name: '近景', position: [4, -3, 10], target: [-5, 13, 0], zoom: 2 },
  { name: '反向', position: [-30, 42, 18], target: [-5, 13, 0], zoom: 1 },
  { name: '边缘', position: [22, 15, 6], target: [-13, 18, 0], zoom: 1.5 },
  { name: '俯视', position: [-5, 12.99, 45], target: [-5, 13, 0], zoom: 1 },
] as const
